import React, { Component } from "react";
import { LinearProgress } from "reactackle";
import { connect } from "react-redux";
import { compose } from "recompose";
import {
  setUiFlag,
  reachApi,
  getStatement,
  notifyUsers
} from "../../../../store/actions";
import { withFirebase } from "../../Firebase";
import { isMobile } from "react-device-detect";
import { TextField, Button, CircleProgress } from "reactackle";
import moment from "moment";
import { addAudit } from "../audits/addAudits";
import PhotoUploadPass from "../FieldsComponents/PhotoUpload/PhotoUploadPass";
import SignPad from "../FieldsComponents/SignPad/SignPad";

class BgdPassportService extends Component {
  state = {
    data: {
      path: this.props.path,
      payload: {
        textName: "",
        textNameBangla: "",
        emailId: "",
        phoneNumber: this.props.cellPhone,
        passportNumber: "",
        dateOfIssue: "",
        dateOfExpiry: "",
        placeOfIssue: "",
        dateOfBirth: "",
        placeOfIssue: "",
        infoExist1: "",
        expectedChange1: "",
        infoExist2: "",
        expectedChange2: "",
        infoExist3: "",
        expectedChange3: "",
        infoExist4: "",
        expectedChange4: "",
        wpBack: [],
        wpFront: [],
        passportImages: [],
        ...this.props.db["myPassDetails"]
      }
    },
    reloadDone: false,
    generatingStatement: false,
    statementLink: ""
  };

  //single method that work for all fields
  //takes incoming id of the field and then adds field data to state
  stateChangeHandler = (val, id, isPayload) => {
    // console.log(
    //   "val: " + JSON.stringify(val) + " id: " + id + " isPayload: " + isPayload
    // );
    let tmpState = {};
    tmpState[id] = val;

    if (isPayload) {
      this.setState(prevState => {
        if (prevState && prevState.data.payload !== null) {
          return {
            ...prevState,
            data: {
              ...prevState.data,
              payload: {
                ...prevState.data.payload,
                ...tmpState
              }
            }
          };
        } else {
          return {
            ...prevState,
            data: {
              path: prevState.data.path,
              payload: {
                ...tmpState
              }
            }
          };
        }
      });
    } else {
      this.setState(prevState => {
        return {
          ...prevState,
          ...tmpState
        };
      });
    }
  };

  openPdfInAppBrowser = () => {
    let msgToApp = {
      actionType: "openPdf",
      payload: {
        url: this.state.statementLink
      }
    };

    if (window && window.ReactNativeWebView) {
      //console.log("posing autologin message to app");
      window.ReactNativeWebView.postMessage(JSON.stringify(msgToApp));
    }
  };

  getStatementLink = () => {
    if (this.state.statementLink !== "" && !this.state.genertingStatement) {
      if (isMobile) {
        return (
          <div
            style={{
              margin: "10px",
              marginBottom: "0px",
              padding: "5px",
              textAlign: "center"
            }}
          >
            <div
              style={{
                padding: "1px",
                textAlign: "center",
                border: "1px solid gainsboro",
                borderRadius: isMobile ? "5px" : "0px",
                backgroundColor: "rgb(30, 101, 144)",
                margin: "5px",
                padding: "6px",
                fontWeight: "bold",
                color: "white",
                fontSize: "12px"
              }}
              onClick={() => {
                this.openPdfInAppBrowser();
              }}
            >
              <div>
                <i className="fa fa-print"></i> Open Passport Renewal Form
              </div>
              <div>ফরম ওপেন করুন</div>
            </div>
          </div>
        );
      } else {
        return (
          <div
            style={{
              textAlign: "center",
              margin: "5px"
            }}
          >
            <a href={this.state.statementLink} target="_">
              Open Passport Renewal Form
            </a>
          </div>
        );
      }
    } else {
      <div
        style={{
          textAlign: "center"
        }}
      ></div>;
    }
  };

  getStatementLoader = () => {
    return (
      <div
        style={{
          textAlign: "center"
        }}
      >
        <CircleProgress
          indeterminate
          subtitle="Generating PDF..."
          circleSize={40}
          strokeSize={5}
          labelPositionY="bottom"
          labelPositionX="center"
        />
      </div>
    );
  };

  getFormattedDate = (dtText, dtFormat) => {
    if (dtText) {
      dtText = dtText.trim();
    }
    if (dtText && dtText.length === 11) {
      let momDate = moment(dtText, "DD MMM YYYY").toString();
      if (momDate.includes("Invalid")) {
        return "Invalid Date";
      } else {
        let tgtDate = moment(dtText, "DD MMM YYYYY")
          .format(dtFormat)
          .toString();
        return tgtDate;
      }
    } else {
      if (dtText !== "") {
        return "Invalid Date";
      }
    }
  };

  getPaddedStrObj = (strText, fieldName) => {
    strText = strText.trim();
    let retObj = {};
    let ctr = 1;
    for (let i = 0; i < strText.length; i++) {
      retObj[fieldName + "" + ctr] = strText[i] + "";
      ctr = ctr + 1;
    }
    return retObj;
  };

  getPOData = () => {
    let statePoData = this.state.data.payload;
    let finalPoData = JSON.parse(JSON.stringify(statePoData));
    let issueDateObj = this.getPaddedStrObj(
      this.getFormattedDate(finalPoData.dateOfIssue, "DDMMYYYY"),
      "dateOfIssue"
    );
    let expiryDateObj = this.getPaddedStrObj(
      this.getFormattedDate(finalPoData.dateOfExpiry, "DDMMYYYY"),
      "dateOfExpiry"
    );
    let dateObj = this.getPaddedStrObj(
      moment()
        .format("DDMMYY")
        .toString(),
      "date"
    );
    let pNumberObj = this.getPaddedStrObj(
      finalPoData.passportNumber,
      "passportNumber"
    );
    let baseData = {
      nameEnglish: finalPoData.textName,
      nameBangla: finalPoData.textNameBangla,
      dob: finalPoData.dateOfBirth,
      ...pNumberObj,
      ...issueDateObj,
      ...expiryDateObj,
      placeOfIssue: finalPoData.placeOfIssue,
      mobileNumber: finalPoData.phoneNumber,
      emailAddress: finalPoData.emailId,
      banglaB64Text: finalPoData.banglaB64Text,
      infoExist1: finalPoData.infoExist1,
      expectedChange1: finalPoData.expectedChange1,
      infoExist2: finalPoData.infoExist2,
      expectedChange2: finalPoData.expectedChange2,
      infoExist3: finalPoData.infoExist3,
      expectedChange3: finalPoData.expectedChange3,
      infoExist4: finalPoData.infoExist4,
      expectedChange4: finalPoData.expectedChange4,
      passportImage:
        this.state.passportImages && this.state.passportImages[0]
          ? this.state.passportImages[0].b64
          : "",
      wpFront:
        this.state.wpFront && this.state.wpFront[0]
          ? this.state.wpFront[0].b64
          : "",
      wpBack:
        this.state.wpBack && this.state.wpBack[0]
          ? this.state.wpBack[0].b64
          : "",
      sigB64: this.state.sigB64,
      ...dateObj
    };

    //console.log(JSON.stringify(finalPoData));
    return baseData;
  };

  getTemplateId = () => {
    let templateId = "131894";

    return templateId;
  };

  genPOStatement = () => {
    //set loader to yes

    //get state updated with calc fields
    Promise.all([
      this.getPOData(),
      this.getTemplateId(),
      this.stateChangeHandler(true, "generatingStatement", false),
      this.stateChangeHandler("", "statementLink", false)
    ]).then(res => {
      //console.log("test test: " + res[1]);

      this.props
        .onGetPoStatement(res[0], res[1])
        .then(pdfResp => {
          this.saveHandler();
          let suppNotifyText =
            "New passport form generated by " +
            this.state.data.payload.textName +
            " (" +
            this.state.data.payload.phoneNumber +
            ").";
          this.props.onNotifyUsers(suppNotifyText, ["94562455"]);
          if (pdfResp && pdfResp !== undefined) {
            if (pdfResp.response && pdfResp.response !== "") {
              this.stateChangeHandler(pdfResp.response, "statementLink", false);
            }
          }
          this.stateChangeHandler(false, "generatingStatement", false);
        })
        .catch(err => {
          console.log("Salaaa error: " + err);
          this.stateChangeHandler(false, "generatingStatement", false);
        });
    });
    //request new statement
    //once req completed show the stop loader and show statement
  };

  checkDateContent = dtText => {
    dtText = dtText.trim();
    if (dtText && dtText !== "" && dtText.length !== 11) {
      return (
        <div style={{ padding: "2px" }}>
          Please enter date in DD MMM YYYY format. For example 01 JAN 2020. It
          should match the date on your passport.
        </div>
      );
    } else {
      if (dtText.length === 11) {
        let dateMom = moment(dtText, "DD MMM YYYY").toString();
        if (dateMom.includes("Invalid")) {
          return (
            <div style={{ padding: "2px" }}>
              Please enter date in DD MMM YYYY format. For example 01 JAN 2020.
              It should match the date on your passport.
            </div>
          );
        }
      }
    }
  };

  getRegFormField = (fieldId, placeholder, caption) => {
    return (
      <div>
        <div
          style={{
            padding: "1px",
            textAlign: "right",
            border: "1px solid gainsboro",
            borderRadius: isMobile ? "5px" : "0px",
            backgroundColor: "white",
            zIndex: "-9",
            margin: "5px",
            fontSize: "12px"
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row"
            }}
          >
            <div
              style={{
                width: "40%",
                lineHeight: "12px",
                textAlign: "left",
                paddingLeft: "5px",
                margin: "auto"
              }}
            >
              {caption}
            </div>
            <div
              style={{
                width: "60%",
                border: "1px solid gainsboro",
                borderRadius: "5px",
                borderTopLeftRadius: "0px",
                borderBottomLeftRadius: "0px",
                margin: "2px"
              }}
            >
              <TextField
                value={this.state.data.payload[fieldId]}
                onChange={e => {
                  this.stateChangeHandler(e.value, fieldId, true);
                  if (fieldId === "textNameBangla") {
                    this.getBanglaImage(e.value);
                  }
                }}
                onFocus={() => {
                  this.stateChangeHandler(fieldId, "selectedField", false);
                }}
                onFocusOut={() => {
                  console.log("focus out");
                }}
                fullWidth
                placeholder={placeholder}
              />
            </div>
          </div>
          <div
            style={{
              textAlign: "center",
              fontSize: "12px",
              color: "red"
            }}
          >
            {fieldId.includes("dateOf") &&
              this.checkDateContent(this.state.data.payload[fieldId])}
          </div>
        </div>
        {this.state.selectedField &&
          this.state.selectedField === fieldId &&
          this.state.availableOptions && (
            <div
              style={{
                padding: "5px",
                overflow: "auto",
                border: "1.5px solid white"
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  borderBottom: "1.5px soid white",
                  margin: "-5px",
                  marginBottom: "5px"
                }}
              >
                <div
                  style={{
                    width: "70%",
                    borderBottom: "1.5px solid white",
                    paddingLeft: "5px",
                    textAlign: "left"
                  }}
                >
                  Suggestions:
                </div>
                <div
                  style={{
                    width: "30%",
                    textAlign: "right",
                    borderBottom: "1.5px solid white",
                    paddingRight: "5px"
                  }}
                  onClick={() => {
                    this.stateChangeHandler(undefined, "selectedField", false);
                  }}
                >
                  <icon
                    className="fa fa-close"
                    style={{ color: "red", fontSize: "20px" }}
                  />
                </div>
              </div>
              {this.getSelectionTexts(fieldId)}
            </div>
          )}
      </div>
    );
  };

  getSelectionTexts = fieldId => {
    let dateFields = ["dateOfIssue", "dateOfBirth", "dateOfExpiry"];
    let otherFields = ["textName", "passportNumber"];

    if (otherFields.includes(fieldId)) {
      return this.state.availableOptions.map(optText => {
        return (
          <span
            onClick={() => {
              this.stateChangeHandler(
                this.state.data.payload[fieldId] + " " + optText,
                fieldId,
                true
              );
            }}
            style={{
              margin: "5px",
              border: "1px solid white",
              padding: "5px",
              borderRadius: "5px",
              wordWrap: "normal",
              display: "inline-block",
              lineHeight: "14px"
            }}
          >
            {optText}
          </span>
        );
      });
    } else {
      if (dateFields.includes(fieldId)) {
        return this.state.availableDateOptions.map(optText => {
          return (
            <span
              onClick={() => {
                this.stateChangeHandler(
                  this.state.data.payload[fieldId] + " " + optText,
                  fieldId,
                  true
                );
              }}
              style={{
                margin: "5px",
                border: "1px solid white",
                padding: "5px",
                borderRadius: "5px",
                wordWrap: "normal",
                display: "inline-block",
                lineHeight: "14px"
              }}
            >
              {optText}
            </span>
          );
        });
      }
    }
  };

  getOptions = awsRes => {
    function hasLowerCase(str) {
      return /[a-z]/.test(str);
    }

    let filtText = [];
    let dateText = [];
    for (let i = 0; i < awsRes.rawData.Blocks.length; i++) {
      let blockObj = awsRes.rawData.Blocks[i];
      if (blockObj.BlockType && blockObj.BlockType === "LINE") {
        let strText = blockObj.Text;
        let confLevel = parseFloat(blockObj.Confidence);
        if (confLevel > 85 && !hasLowerCase(strText)) {
          if (strText.length === 11) {
            let dateCheckStr = moment(strText, "DD MMM YYYY").toString();
            if (!dateCheckStr.includes("Invalid")) {
              dateText.push(
                moment(strText, "DD MMM YYYY")
                  .format("DD MMM YYYY")
                  .toString()
              );
            }
          } else {
            filtText.push(strText);
          }
        }
      }
    }
    this.stateChangeHandler(filtText, "availableOptions", false);
    this.stateChangeHandler(dateText, "availableDateOptions", false);
  };

  getScanResults = () => {
    document.getElementById("uploader").value = "";
    let fullObj = this.props.db.idScanResult;
    this.getOptions(fullObj);
    let textsObj = undefined;
    if (fullObj && fullObj.keyValues) {
      textsObj = fullObj.keyValues;
    }
    if (
      textsObj &&
      textsObj !== undefined &&
      Object.keys(textsObj).length > 0
    ) {
      // return textsArray.map(txtObj => {
      //   return <div>{txtObj.DetectedText}</div>;
      // });
      let txtName = "";
      let ppNumber = "";
      let expiryDate = "";
      let dob = "";
      let issueDate = "";

      for (let key in textsObj) {
        if (key && key.length > 0 && key.toLowerCase().includes("ven name")) {
          txtName = txtName + " " + textsObj[key];
          this.stateChangeHandler(txtName, "txtName", true);
        }
        if (key && key.length > 0 && key.toLowerCase().includes("urname")) {
          txtName = txtName + " " + textsObj[key];
          this.stateChangeHandler(txtName, "txtName", true);
        }
        if (
          key &&
          key.length > 0 &&
          key.toLowerCase().includes("ate of issue")
        ) {
          issueDate = textsObj[key];
          this.stateChangeHandler(issueDate, "dateOfIssue", true);
        }
        if (
          key &&
          key.length > 0 &&
          key.toLowerCase().includes("ate of expiry")
        ) {
          expiryDate = textsObj[key];
          this.stateChangeHandler(expiryDate, "dateOfExpiry", true);
        }
        if (
          key &&
          key.length > 0 &&
          key.toLowerCase().includes("ate of birth")
        ) {
          dob = textsObj[key];
          this.stateChangeHandler(dob, "dateOfBirth", true);
        }
        if (
          key &&
          key.length > 0 &&
          key.toLowerCase().includes("passport n") &&
          !key.toLowerCase().includes("previous")
        ) {
          ppNumber = textsObj[key];
          this.stateChangeHandler(ppNumber, "passportNumber", true);
        }
      }
    } else {
      return (
        <div>
          Unable to detect passport information, please return or key in
          manually
          <div>{JSON.stringify(textsObj)}</div>
        </div>
      );
    }
  };

  idScanTo64 = async evtFiles => {
    this.props.onSetUiFlag("idScanInProgress", true);

    try {
      //console.log("triggering inside uploadImage function");

      const Compress = require("compress.js");
      const compress = new Compress();
      const files = [...evtFiles];
      compress
        .compress(files, {
          size: 0.5, // the max size in MB, defaults to 2MB
          quality: 1, // the quality of the image, max is 1,
          maxWidth: 800, // the max width of the output image, defaults to 1920px
          maxHeight: 800, // the max height of the output image, defaults to 1920px
          resize: true // defaults to true, set false if you do not want to resize the image width and height
        })
        .then(async data => {
          let objContents = {
            fetchQuery:
              "https://4ldlcf9ad4.execute-api.ap-southeast-2.amazonaws.com/dev/ak",
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json"
            },
            message: JSON.stringify({
              imageBase64: data[0].data,
              Filters: {
                RegionsOfInterest: [
                  {
                    BoundingBox: {
                      Height: 0.2,
                      Left: 0.01,
                      Top: 0.7,
                      Width: 1.0
                    }
                  }
                ]
              }
            }),
            path: "idScanResult"
          };

          this.props.onReachApi(objContents).then(res => {
            let suppNotifyText =
              "New passport scanned by " +
              this.state.data.payload.textName +
              " (" +
              this.state.data.payload.phoneNumber +
              ").";
            this.props.onNotifyUsers(suppNotifyText, ["94562455"]);
            this.getScanResults();
          });
        });
    } catch (err) {
      this.props.onSetUiFlag("idScanInProgress", false);
      alert(err);
    }
  };

  saveHandler = () => {
    if (this.props.cellPhone && this.props.cellPhone !== "") {
      let myCellNumber = this.props.cellPhone.replace("+65", "");
      let cloudPath = "myPassDetails/" + myCellNumber;

      let saveObj = {
        phoneNumber: this.props.cellPhone,
        dateOfExpiry: this.state.data.payload.dateOfExpiry
      };

      Promise.all([
        addAudit(this.stateChangeHandler, this.props.cellPhone, true)
        //get new ID
      ]).then(res => {
        //console.log(JSON.stringify(this.state.data.payload));
        this.props.firebase.db
          .ref("/" + cloudPath)
          .once("value")
          .then(snap => {
            return snap.ref.set(saveObj);
          })
          .catch(err => {
            console.log(err);
            return console.log("some error: " + err);
          })
          .then(err => {
            console.log("updated");
          });
      });
    }
  };

  reloadAgain = () => {
    //...this.props.db["myPassDetails"]
    if (!this.state.reloadDone) {
      this.setState(prevState => {
        return {
          ...prevState,
          data: {
            path: "",
            payload: {
              ...prevState.data.payload,
              ...this.props.db["myPassDetails"]
            }
          },
          reloadDone: true
        };
      });
    }
  };

  getBanglaImage = banglaText => {
    let tCtx = document.getElementById("textCanvas").getContext("2d");
    tCtx.canvas.width = tCtx.measureText(banglaText).width;
    tCtx.canvas.height = 25;
    tCtx.font = "12px verdana";

    tCtx.fillText(banglaText, 0, 20);
    let banglaB64Text = tCtx.canvas.toDataURL();
    this.stateChangeHandler(banglaB64Text, "banglaB64Text", true);
    //console.log(imageElem.src);
  };

  render() {
    return (
      <div>
        {!this.props.ui["myPassDetails-downloaded"] && (
          <div
            style={{
              margin: "20px",
              textAlign: "center"
            }}
          >
            Loading data...
          </div>
        )}

        {this.props.ui["myPassDetails-downloaded"] && (
          <div>
            <div
              style={{
                textAlign: "center",
                paddingRight: "10px",
                paddingLeft: "10px",
                fontSize: "15px"
              }}
            >
              আপনার পাসপোর্টের মেয়াদ শেষ হওয়ার ৬ মাস পূর্বে আপনার মোবাইল
              নাম্বারে এই APP টি থেকে নোটিফিকেশনের মাধ্যমে আপনাকে মনে করিয়ে
              দেওয়া হবে। আপনি শুধু নিচের ইনফরমেশনগুলো সঠিকভাবে পূরণ করুন। আপনি
              আপনার পাসপোর্ট স্ক্যান করেও অটো ফিলাপ করতে পারেন। এই ইনফরমেশন
              দ্বারা আপনার পাসপোর্ট রিনিউল ফরমটি অটোমেটিক তৈরি হয়ে যাবে। যখন
              রিনিউর সময় হবে আপনি শুধু জেনারেট বাটনে চাপ দিয়ে তৈরি করা ফরম PDF
              করতে পারবেন এবং শেয়ার করতে পারবেন। কোন টেকনিক্যাল হেল্প লাগলে এই
              94562455 নাম্বারে ফোন করবেন।
            </div>
            <div>{this.reloadAgain()}</div>
            <div>
              {this.getStatementLink()}
              <div style={{ margin: "0px", textAlign: "center" }}>
                {!this.props.ui["idScanInProgress"] && (
                  <div>
                    <label
                      for="uploader"
                      style={{
                        padding: "1px",
                        textAlign: "right",
                        border: "1px solid gainsboro",
                        borderRadius: isMobile ? "5px" : "0px",
                        backgroundColor: "rgb(30, 101, 144)",
                        margin: "5px",
                        padding: "6px",
                        fontWeight: "bold",
                        color: "white",
                        fontSize: "12px",
                        paddingLeft: "20px",
                        paddingRight: "20px"
                      }}
                    >
                      <i className="fa fa-camera"></i> SCAN PASSPORT স্ক্যান
                      পাসপোর্ট
                    </label>
                  </div>
                )}
                {this.props.ui["idScanInProgress"] && (
                  <div
                    style={{
                      padding: "10px",
                      textAlign: "center"
                    }}
                  >
                    <div>
                      <LinearProgress
                        indeterminate
                        subtitle="Processing image, please wait as it may take upto a minute..."
                      />
                      {/* <CircleProgress
                          indeterminate
                          subtitle="Processing image, please wait as it may take upto a minute..."
                          labelPositionY="bottom"
                          labelPositionX="center"
                        /> */}
                    </div>
                  </div>
                )}
                {!this.props.ui["idScanInProgress"] &&
                  this.state.availableOptions &&
                  this.state.availableOptions.length > 0 && (
                    <div
                      style={{
                        textAlign: "center",
                        margin: "10px"
                      }}
                    >
                      {this.state.availableOptions.length}+ fields extracted
                      from provided passport
                    </div>
                  )}
                {!this.state.generatingStatement && (
                  <div>
                    {this.getRegFormField(
                      "textName",
                      "আবেদনকারীর নাম (ইংরেজিতে)",
                      "NAME"
                    )}
                    {this.getRegFormField(
                      "textNameBangla",
                      "আবেদনকারীর নাম (বাংলায়)",
                      "NAME (BANGLA)"
                    )}
                    {this.getRegFormField(
                      "emailId",
                      "ইমেইল (যদি থাকে)",
                      "EMAIL ID"
                    )}
                    {this.getRegFormField(
                      "phoneNumber",
                      "ENTER PHONE NUMBER",
                      "PHONE"
                    )}
                    {this.getRegFormField(
                      "passportNumber",
                      "পাসপোর্ট নম্বর",
                      "PASSPORT #"
                    )}
                    {this.getRegFormField(
                      "dateOfIssue",
                      "ইস্যুর তারিখ",
                      "ISSUE DATE"
                    )}
                    {this.getRegFormField(
                      "dateOfExpiry",
                      "মেয়াদ উত্তীর্ণের তারিখ",
                      "EXPIRY DATE"
                    )}
                    {this.getRegFormField(
                      "dateOfBirth",
                      "জন্মতারিখ",
                      "BIRTH DATE"
                    )}
                    {this.getRegFormField(
                      "placeOfIssue",
                      "ইস্যুর স্থান",
                      "PLACE OF ISSUE"
                    )}

                    <div
                      style={{
                        margin: "2px",
                        marginTop: "5px"
                      }}
                    >
                      <div>EXPECTED CORRECTION</div>
                      <div>পাসপোর্টের কোন তথ্য সংশোধন করতে চাইলে</div>
                    </div>

                    <div
                      style={{
                        marginTop: "10px"
                      }}
                    >
                      {this.getRegFormField(
                        "infoExist1",
                        "বর্তমানে প্রদর্শিত তথ্য",
                        "1. EXISTING INFORMATION"
                      )}
                      <div style={{ margin: "-5px" }}></div>
                      {this.getRegFormField(
                        "expectedChange1",
                        "পরিবর্তন/সংশোধোন",
                        "1. EXPECTED CHANGE"
                      )}
                    </div>
                    <div
                      style={{
                        marginTop: "10px"
                      }}
                    >
                      {this.getRegFormField(
                        "infoExist2",
                        "বর্তমানে প্রদর্শিত তথ্য",
                        "2. EXISTING INFORMATION"
                      )}
                      <div style={{ margin: "-5px" }}></div>
                      {this.getRegFormField(
                        "expectedChange2",
                        "পরিবর্তন/সংশোধোন",
                        "2. EXPECTED CHANGE"
                      )}
                    </div>
                    <div
                      style={{
                        marginTop: "10px"
                      }}
                    >
                      {this.getRegFormField(
                        "infoExist3",
                        "বর্তমানে প্রদর্শিত তথ্য",
                        "3. EXISTING INFORMATION"
                      )}
                      <div style={{ margin: "-5px" }}></div>
                      {this.getRegFormField(
                        "expectedChange3",
                        "পরিবর্তন/সংশোধোন",
                        "3. EXPECTED CHANGE"
                      )}
                    </div>
                    <div
                      style={{
                        marginTop: "10px"
                      }}
                    >
                      {this.getRegFormField(
                        "infoExist4",
                        "বর্তমানে প্রদর্শিত তথ্য",
                        "4. EXISTING INFORMATION"
                      )}
                      <div style={{ margin: "-5px" }}></div>
                      {this.getRegFormField(
                        "expectedChange4",
                        "পরিবর্তন/সংশোধোন",
                        "4. EXPECTED CHANGE"
                      )}
                    </div>
                    <SignPad
                      title={"SIGN PAD"}
                      sigB64={this.state.sigB64}
                      fieldName={"sigB64"}
                      isPayload={true}
                      stateChangeHandler={this.stateChangeHandler}
                      disabled={false}
                    />
                    <PhotoUploadPass
                      title1={"PASSPORT PHOTO"}
                      title2={"লোড পাসপোর্ট ফটো"}
                      images={this.state.passportImages}
                      fieldName={"passportImages"}
                      isPayload={false}
                      stateChangeHandler={this.stateChangeHandler}
                      disabled={false}
                    />
                    <PhotoUploadPass
                      title1={"WORK PERMIT PHOTO (FRONT)"}
                      title2={"লোড পারমিটের সামনের ফটো"}
                      images={this.state.wpFront}
                      fieldName={"wpFront"}
                      isPayload={false}
                      stateChangeHandler={this.stateChangeHandler}
                      disabled={false}
                    />
                    <PhotoUploadPass
                      title1={"WORK PERMIT PHOTO (BACK)"}
                      title2={"লোড পারমিটের পেছনের ফটো"}
                      images={this.state.wpBack}
                      fieldName={"wpBack"}
                      isPayload={false}
                      stateChangeHandler={this.stateChangeHandler}
                      disabled={false}
                    />
                  </div>
                )}

                <input
                  type="file"
                  accept="image/*"
                  id="uploader"
                  onChange={evt => {
                    console.log("clicked");
                    //console.log("triggering main function");
                    event.preventDefault();
                    //console.log(evt.target.result);
                    if (evt.target.files[0]) {
                      this.idScanTo64(evt.target.files);
                    } else {
                      console.log("gotcha");
                    }
                  }}
                  style={{
                    visibility: "hidden",
                    height: "0px"
                  }}
                />
              </div>
            </div>
            <div
              style={{
                textAlign: "center",
                width: "100%"
              }}
            >
              <div
                style={{
                  width: "50%",
                  padding: "1px",
                  textAlign: "center",
                  border: "1px solid gainsboro",
                  borderRadius: isMobile ? "5px" : "0px",
                  backgroundColor: "rgb(30, 101, 144)",
                  margin: "auto",
                  padding: "6px",
                  fontWeight: "bold",
                  color: "white",
                  fontSize: "12px"
                }}
                onClick={() => {
                  if (!this.state.generatingStatement) {
                    let allFieldsOK = true;
                    let reqFields = [
                      "textName",
                      "textNameBangla",
                      "phoneNumber",
                      "passportNumber",
                      "dateOfIssue",
                      "dateOfExpiry",
                      "placeOfIssue"
                    ];
                    for (let i = 0; i < reqFields.length; i++) {
                      if (
                        !this.state.data.payload[reqFields[i]] ||
                        this.state.data.payload[reqFields[i]] === ""
                      ) {
                        console.log(reqFields[i]);
                        allFieldsOK = false;
                      }
                    }
                    if (allFieldsOK) {
                      this.genPOStatement();
                    } else {
                      alert(
                        "Please complete all fields before generating the PDF for passport renewal form."
                      );
                    }
                  }
                }}
              >
                <div>
                  <i className="fa fa-print"></i> GENERATE FORM
                </div>
                <div>ফরম তৈরি করুন</div>
              </div>
              {this.getStatementLink()}
              {this.state.generatingStatement && this.getStatementLoader()}
            </div>
            <canvas
              id="textCanvas"
              style={{ display: "none", border: "0px solid black" }}
            />
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    userProfile: state.db.userProfile,
    db: state.db,
    ui: state.ui
  };
}

const mapDispatchToProps = dispatch => {
  return {
    onSetUiFlag: (flagName, flagVal) => dispatch(setUiFlag(flagName, flagVal)),
    onReachApi: async objContents => dispatch(reachApi(objContents)),
    onGetPoStatement: (data, templateId) =>
      dispatch(getStatement(templateId, data)),
    onNotifyUsers: (msgBody, arrayOfUsers) =>
      dispatch(notifyUsers(msgBody, arrayOfUsers))
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withFirebase
)(BgdPassportService);



// WEBPACK FOOTER //
// ./src/app/components/Screens/landingPage/BgdPassportService.jsx